import { crmWSApiRequest } from '@/api/external/crmWSApiRequest';
import { getPartnerBySlug } from '@/api/partners/getPartnerBySlug';
import type { IPartner } from '@/types';

type IPartnerCRMData = Pick<
  IPartner,
  | 'AllowWhiteLabel'
  | 'LogoFile'
  | 'PrimaryColor'
  | 'SecondaryColor'
  | 'TertiaryColor'
  | 'PrimaryTextColor'
  | 'SecondaryTextColor'
  | 'StoreUrl'
  | 'StorePhone'
  | 'StoreEmail'
  | 'MarketplaceName'
  | 'MarketplaceDesc'
  | 'TermsOfService'
  | 'PrivacyPolicy'
> & { ProfileID: string };

const APPLIED_DOMAIN = import.meta.env.VITE_APPLIED_DOMAIN || '';

export function extractPartnerName(url: string) {
  if (import.meta.env.VITE_DEV_PARTNER) {
    return import.meta.env.VITE_DEV_PARTNER as string;
  }

  if (!APPLIED_DOMAIN) return '';

  const hostname = new URL(url).hostname;

  if (hostname.endsWith(APPLIED_DOMAIN)) {
    const index = hostname.lastIndexOf(APPLIED_DOMAIN);

    const subdomain = hostname.substring(0, index - 1); // -1 to remove the trailing dot

    const parts = subdomain.split('.');
    return parts.length > 0 ? parts[parts.length - 1] : '';
  }

  return '';
}

export function currentPartnerQuery() {
  const slug = 'rate';

  return {
    queryKey: ['current-partner', slug],
    queryFn: async () => {
      if (!slug) {
        return null;
      }

      const {
        data: { data: partnerData },
      } = await getPartnerBySlug();
      if (!partnerData) {
        return null;
      }

      const response = await crmWSApiRequest<{
        Results: { Partners: IPartnerCRMData[] };
      }>('partner-list', {
        ProfileID: partnerData.profile_id,
      });

      const partnerCRMData = response.Results.Partners.find(
        (data) =>
          data.ProfileID.toString() === partnerData.profile_id.toString()
      );

      if (!partnerCRMData) {
        return null;
      }

      const partner: IPartner = {
        ...partnerData,
        ...partnerCRMData,
      };
      return partner;
    },
    staleTime: Number.POSITIVE_INFINITY,
  };
}
